import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ExplanationIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M11 9.44V7.534c0-.114 0-.171-.016-.221a.3.3 0 0 0-.07-.119.7.7 0 0 0-.18-.114L8 5.634m-4.8.635v4.317c0 .236 0 .354.035.457a.64.64 0 0 0 .146.242c.075.076.176.126.379.224l3.84 1.86c.147.072.22.108.297.122a.6.6 0 0 0 .206 0c.076-.014.15-.05.297-.121l3.84-1.861c.203-.098.304-.148.379-.224a.64.64 0 0 0 .146-.242c.035-.103.035-.22.035-.457V6.27M2 5.634l5.785-3.058a.6.6 0 0 1 .16-.07.3.3 0 0 1 .11 0c.042.008.08.028.16.07L14 5.634 8.215 8.692c-.08.042-.118.063-.16.071a.3.3 0 0 1-.11 0c-.042-.008-.081-.029-.16-.07z" /></svg>
  );
}

export default ExplanationIcon;
